import { type FC } from 'react';

import Text from 'components/_core/Text';

import GuidanceBaseHelp from './Base/GuidanceBaseHelp';
import locales from './locales';

/**
 * Help-like guidance to explain the draft statutes
 */
const GuidanceStatutesDefinition: FC = () => {
  const loc = locales.statutesDefinition;

  return (
    <GuidanceBaseHelp title={loc.title}>
      <Text color="inherit" fontSize="inherit">
        {loc.content}
      </Text>
    </GuidanceBaseHelp>
  );
};

export default GuidanceStatutesDefinition;
